import {CLASSROOM_IN_LEERPLATFORM, classroomApiUrl} from '@/classroom/classroomApiUrl.js';
import {EXPERTISE_IN_LEERPLATFORM, expertiseApiUrl} from '@/expertise/expertiseApiUrl.js';
import {
    LEARNING_PLAN_IN_LEERPLATFORM,
    learningPlanApiUrl,
} from '@/learningplan/learningPlanApiUrl.js';

/** Whether the portal has switched all three features (ADR 0008) over: the other item types have no flag of their own. */
const allSwitched = (settings) =>
    settings.enabledFeatureFlags?.[CLASSROOM_IN_LEERPLATFORM] &&
    settings.enabledFeatureFlags?.[LEARNING_PLAN_IN_LEERPLATFORM] &&
    settings.enabledFeatureFlags?.[EXPERTISE_IN_LEERPLATFORM];

/**
 * The base url of the payment hook (`enrollmenthook`, `subscriptionhook`) for what is bought: the host that serves the
 * feature of the item. The academy refuses a buy of an item whose feature a portal has switched over (ADR 0008), the
 * leerplatform buys anything, so for the flagged items the screens go to the leerplatform exactly when the academy
 * would refuse. A planning or classroom course follows classroom, a learning-plan item learning plans, an expertise
 * item expertise. The other items (a microlearning, a learning path, a composition) have no flag of their own and the
 * academy never refuses them; both sides answer their hook from the shared Academy database whichever host serves it,
 * so once the portal has switched all three features over they follow to the leerplatform — a portal without a legacy
 * academy site has no `portalApiUrl` to fall back on — and until then they stay with the academy.
 *
 * @param {object} settings the minervaSettings
 * @param {{targetType?: string, planningId?: string}} item the catalog item type, and the planning when one is bought
 * @returns {string}
 */
export const paymentApiUrlFor = (settings, {targetType, planningId} = {}) => {
    if (planningId) return classroomApiUrl(settings);

    switch (targetType?.toLowerCase()) {
        case 'classroom':
            return classroomApiUrl(settings);
        case 'learningplan':
            return learningPlanApiUrl(settings);
        case 'expertise':
            return expertiseApiUrl(settings);
        default:
            return allSwitched(settings) ? settings.apiUrl : settings.portalApiUrl;
    }
};
